import * as coreEntities from 'core/store/index';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const DEFAULT_TEACHER_LIBRARY_MAX_ITEMS = 10;
export const DEFAULT_TEACHER_LIBRARY_MAX_FOLDERS = 10;

function useSystemSettings() {
  const settings = useSelector((state) => coreEntities.systemSettings.selectors.getSystemSettings(state));
  const client = useSelector((state) => coreEntities.organization.selectors.getClient(state));

  const [loading, setLoading] = useState(true);
  const [enableAdvancedProgramming, setEnableAdvancedProgramming] = useState(undefined);
  const [enableEvaluationModel, setEnableEvaluationModel] = useState(undefined);
  const [enableProgramLookAdvanced, setEnableProgramLookAdvanced] = useState(undefined);
  const [enableNutrient, setEnableNutrient] = useState(undefined);
  const [enableNutrientStandalone, setEnableNutrientStandalone] = useState(undefined);
  const [nutrientLicence, setNutrientLicence] = useState(undefined);
  const [enableLibrary, setEnableLibrary] = useState(undefined);
  const [enableLessonItemComments, setEnableLessonItemComments] = useState(undefined);
  const [enableClassroomResources, setEnableClassroomResources] = useState(undefined);
  const [enableThirdPartyIntegrations, setEnableThirdPartyIntegrations] = useState(undefined);
  const [enableTeacherConfigCourse, setEnableTeacherConfigCourse] = useState(undefined);
  const [enableOverlays, setEnableOverlays] = useState(undefined);
  const [enablePrograming, setEnablePrograming] = useState(undefined);
  const [teacherLibraryMaxItems, setTeacherLibraryMaxItems] = useState(DEFAULT_TEACHER_LIBRARY_MAX_ITEMS);
  const [teacherLibraryMaxFolders, setTeacherLibraryMaxFolders] = useState(DEFAULT_TEACHER_LIBRARY_MAX_FOLDERS);

  useEffect(() => {
    if (settings && client) {
      setEnableAdvancedProgramming(settings?.enable_advanced_programming === 1);
      setEnableEvaluationModel(settings?.enable_evaluation_model === 1);
      setEnableProgramLookAdvanced(settings?.enable_program_look_advanced === 1);
      setEnableNutrient(settings?.enable_nutrient === 1);
      setEnableNutrientStandalone(settings?.enable_nutrient_standalone === 1);
      setNutrientLicence(settings?.nutrient_licence || '');
      setEnableLibrary(settings?.enable_library === 1);
      setEnableLessonItemComments(settings?.show_item_comments === 1);
      setEnableClassroomResources(settings?.show_program_resources === 1);
      setEnableThirdPartyIntegrations(settings?.third_party_integrations === 1);
      setEnableTeacherConfigCourse(settings?.enable_teacher_config_course === 1);
      setEnableOverlays(settings?.enable_overlays === 1);
      setEnablePrograming(settings?.enable_programing === 1);
      setTeacherLibraryMaxItems(settings?.teacher_library_max_items ?? DEFAULT_TEACHER_LIBRARY_MAX_ITEMS);
      setTeacherLibraryMaxFolders(settings?.teacher_library_max_folders ?? DEFAULT_TEACHER_LIBRARY_MAX_FOLDERS);
      setLoading(false);
    }
  }, [settings, client]);

  return {
    enableAdvancedProgramming,
    enableEvaluationModel,
    enableNutrient,
    enableNutrientStandalone,
    nutrientLicence,
    enableProgramLookAdvanced,
    enableLessonItemComments,
    enableLibrary,
    enableClassroomResources,
    enableThirdPartyIntegrations,
    enableTeacherConfigCourse,
    enableOverlays,
    enablePrograming,
    teacherLibraryMaxItems,
    teacherLibraryMaxFolders,
    loadingSettings: loading,
  };
}

export default useSystemSettings;
